import { render, staticRenderFns } from "./dualchannel.vue?vue&type=template&id=0204207f&scoped=true&"
import script from "./dualchannel.vue?vue&type=script&lang=js&"
export * from "./dualchannel.vue?vue&type=script&lang=js&"
import style0 from "./dualchannel.vue?vue&type=style&index=0&id=0204207f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0204207f",
  null
  
)

export default component.exports